<!--suppress UnnecessaryLabelJS -->
<template>
	<v-card>
		<v-card-title>
			<v-spacer></v-spacer>
			<v-text-field
				v-model="search"
				append-icon="mdi-magnify"
				label="Search"
				single-line
				hide-details
			></v-text-field>
		</v-card-title>
		<v-data-table
			:headers="headers"
			:items="companies"
			:loading="loading"
			class="elevation-1"
			:mobile-breakpoint="0"
			:search="search"

		>
			<company-row slot="item" slot-scope="props" @edit="onEdit" :company="props.item"/>
		</v-data-table>
	</v-card>
</template>

<script>
	import CompanyRow from "src/view/companies/CompanyRow";
	import {types} from "src/store/modules/Company.module";
	import FilterAble from "src/mixins/FilterAble";

	export default {
		name: "companies-table",
		props: [],
		components: {
			CompanyRow
		},
		mixins: [new FilterAble(types)],
		data() {
			return {
				loading: false,
				headers: [
					{text: "שם המרכז", value: "name"}
				],
				search: null,
				showDialog: false
			};
		},
		computed: {
			companies() {
				return this.$store.state.CompanyModule.companies;
			}
		},
		methods: {
			onEdit(Company) {
				this.$emit("edit", Company);
			}
		}
	};
</script>

<style>

</style>
